/* eslint-disable no-param-reassign,consistent-return */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  billsFaximileWith: true,
};

export const slice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setBillsFaximileWith: (state, action) => {
      state.billsFaximileWith = action.payload;
    },
  },
});

const { reducer, actions } = slice;
const { setBillsFaximileWith } = actions;

export { setBillsFaximileWith };

export default reducer;
